import { ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown } from '@Components/Dropdown';
import { Size } from '@Components/designConstants';
import { companiesSelector } from '../../redux/user';

interface ActivityFeedClientDropdownProps {
  value: string[];
  onChange: (next: string[]) => void;
  placeholder: string;
  clearable?: boolean;
  menuPortalTarget?: HTMLElement | null;
  onMenuClose?: () => void;
}

export const ActivityFeedClientDropdown = ({
  value,
  onChange,
  placeholder,
  clearable,
  menuPortalTarget,
  onMenuClose
}: ActivityFeedClientDropdownProps): ReactNode => {
  const companies = useSelector(companiesSelector);
  // 100–600 companies per user; memoize so the option list isn't rebuilt on every render.
  const options = useMemo(
    () => companies.map(company => ({ label: company.company, value: company.company })),
    [companies]
  );

  // Backspace in the search box never removes a selected client.
  return (
    <Dropdown<string>
      size={Size.LG}
      options={options}
      placeholder={placeholder}
      clearable={clearable}
      menuPortalTarget={menuPortalTarget}
      onMenuClose={onMenuClose}
      fitMenuToContent
      reactSelectProps={{ backspaceRemovesValue: false }}
      searchable
      multiSelect
      value={value}
      onChange={onChange}
    />
  );
};
